import { defineMessages } from "react-intl";

export default defineMessages({
  titleCenterServicesToRead: {
    id: "Unknown.DashboardHeader.titleCenterServicesToRead",
    defaultMessage: "Studies To Read",
  },
  titleAiReports: {
    id: "Unknown.DashboardHeader.titleAiReports",
    defaultMessage: "Appointment Summaries To Review",
  },
  titleAdmin: {
    id: "Unknown.DashboardHeader.titleAdmin",
    defaultMessage: "Admin Dashboard",
  },
});
